<template>
    <div class="col-md-4" v-if="assignment.status == 0">
        <a :href="getUrl(assignment.id)" @click="showAssignmentDetail(assignment)">
            <div class="assginment-item">
                <div class="assginment-item-header">
                    Excercise {{index}}
                </div>
                <div class="assginment-item-body">
                    {{assignment.title}}
                </div>
                <div class="assginment-item-bottom">
                    <p>Due date: </p>
                    <div class="d-flex justify-content-between">
                        <p><b>{{assignment.due_date | convertUnitToTime(' HH:mm - DD/MM/YYYY')}}</b></p>
                        <p><b>{{getStatusText(assignment.status)}}</b> <img src="/themes/web/assets/images/checked-1.svg" alt=""></p>
                    </div>
                </div>
            </div>
        </a>
    </div>
    <div class="col-md-4" v-else-if="assignment.status == 1">
        <a :href="getUrl(assignment.id)">
            <div class="assginment-item assginment-item-available">
                <div class="assginment-item-header">
                    Excercise {{index}}
                </div>
                <div class="assginment-item-body">
                    {{assignment.title}}
                </div>
                <div class="assginment-item-bottom">
                    <p>Available from: </p>
                    <div class="d-flex justify-content-between">
                        <p><b>{{assignment.due_date | convertUnitToTime(' HH:mm - DD/MM/YYYY')}}</b></p>
                        <p><b>{{getStatusText(assignment.status)}}</b> <img src="/themes/web/assets/images/not-start.svg" alt=""></p>
                    </div>
                </div>
            </div>
        </a>
    </div>   
    <div class="col-md-4" v-else-if="assignment.status == 2">
        <a :href="getUrl(assignment.id)" @click="showAssignmentDetail(assignment)">
            <div class="assginment-item assginment-item-expired">
                <div class="assginment-item-header">
                    Excercise {{index}}
                </div>
                <div class="assginment-item-body">
                    {{assignment.title}}
                </div>
                <div class="assginment-item-bottom">
                    <p>Due date: </p>
                    <div class="d-flex justify-content-between">
                        <p><b>{{assignment.due_date | convertUnitToTime(' HH:mm - DD/MM/YYYY')}}</b></p>
                        <p><b>{{getStatusText(assignment.status)}}</b> <img src="/themes/web/assets/images/overdue.svg" alt=""></p>
                    </div>
                </div>
            </div>
        </a>
    </div>  
    <div class="col-md-4" v-else-if="assignment.status == 3">
        <a :href="getUrl(assignment.id)" @click="showAssignmentDetail(assignment)">
            <div class="assginment-item assginment-item-submited">
                <div class="assginment-item-header">
                    Excercise {{index}}
                </div>
                <div class="assginment-item-body">
                    {{assignment.title}}
                </div>
                <div class="assginment-item-bottom">
                    <p>Due date: </p>
                    <div class="d-flex justify-content-between">
                        <p><b>{{assignment.due_date | convertUnitToTime(' HH:mm - DD/MM/YYYY')}}</b></p>
                        <p><b>{{getStatusText(assignment.status)}}</b> <img src="/themes/web/assets/images/checked-2.svg" alt=""></p>
                    </div>
                </div>
            </div>
        </a>
    </div>   
    <div class="col-md-4" v-else-if="assignment.status == 4">
        <a :href="getUrl(assignment.id)" @click="showAssignmentDetail(assignment)">
            <div class="assginment-item assginment-item-finished">
                <div class="assginment-item-header">
                    Excercise {{index}}
                </div>
                <div class="assginment-item-body">
                    {{assignment.title}}
                </div>
                <div class="assginment-item-bottom">
                    <p>Due date: </p>
                    <div class="d-flex justify-content-between">
                        <p><b>{{assignment.due_date | convertUnitToTime(' HH:mm - DD/MM/YYYY')}}</b></p>
                        <b class="d-flex">Point<span class="point">{{assignment.point}}</span></b>
                    </div>
                </div>
            </div>
        </a>
    </div>       
</template>

<script>
import { mapGetters } from 'vuex'
import axios from "axios";

export default {
    name: "AssignmentItem",

    props: ['assignment', 'index', 'lesson_id'],

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return {}
        })
    },

    data() {
        return {};
    },

    created() {

    },

    methods: {
        getStatusText(status){
            switch(status){
                case 0:
                    return 'On-going';
                case 1:
                    return 'Not start';
                case 2:
                    return 'Overdue';
                case 3:
                    return 'Submited';
                case 4:
                    return 'Marked';
                default:
                    return "";                                                                                
            }
        },

        getUrl(id){
            return "#";

            // return "/lesson/"+this.lesson_id+"/assignment/"+id;
        },
        
        showAssignmentDetail(assignment){
            this.$emit('showAssignmentDetail', assignment)
        }
    }
}
</script>

<style scoped>
    .point{
        margin-left: 5px;
        color: #FF0000;
        font-size: 20px;
        font-weight: 1000;
    }
    .assginment-item-bottom{
        /* display: flex; */
    }
</style>
